
let addChat = (state, { payload }) => {
    state.chats.push(payload);
}
export default addChat;